import { create } from 'zustand';

// Importar tipo desde shared/types
import type { Egreso } from '../types';

interface EgresosStore {
  egresos: Egreso[];
  isLoading: boolean;
  error: string | null;
  
  // Actions
  setEgresos: (egresos: Egreso[]) => void;
  addEgresoOptimistic: (egreso: Omit<Egreso, 'id' | 'createdAt' | 'updatedAt'>) => Egreso;
  updateEgresoAfterFirebase: (tempId: string, realEgreso: Egreso) => void;
  removeEgresoOptimistic: (id: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearError: () => void;
  clearAll: () => void;
}

export const useEgresosStore = create<EgresosStore>((set) => ({
  egresos: [],
  isLoading: false,
  error: null,

  setEgresos: (egresos) => {
    set({ egresos });
  },

  addEgresoOptimistic: (egresoData) => {
    const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const newEgreso: Egreso = {
      id: tempId,
      ...egresoData,
      fecha: egresoData.fecha || new Date(),
      createdAt: new Date(),
      updatedAt: new Date(),
    };

    set(state => ({
      egresos: [newEgreso, ...state.egresos]
    }));

    return newEgreso;
  },

  updateEgresoAfterFirebase: (tempId, realEgreso) => {
    set(state => ({
      egresos: state.egresos.map(egreso => 
        egreso.id === tempId ? realEgreso : egreso
      )
    }));
  },

  removeEgresoOptimistic: (id) => {
    set(state => ({
      egresos: state.egresos.filter(egreso => egreso.id !== id)
    }));
  },

  setLoading: (loading) => set({ isLoading: loading }),
  
  setError: (error) => {
    set({ error });
  },
  
  clearError: () => set({ error: null }),
  
  clearAll: () => set({ egresos: [], isLoading: false, error: null }),
}));

